module.exports = __webpack_public_path__ + "media/images/slide_next_btn_sp-ef3b5efb2ae8d7eb3597ffc931705967.png";